import BigNumber from 'bignumber.js';
import { useBoringVaultV1 } from 'boring-vault-ui';
import { useConnection } from 'modules/auth';
import { ZERO } from 'modules/common/const';
import { useEffect, useState } from 'react';

export function useVaultBalance(): {
  balance: BigNumber;
  isLoading: boolean;
} {
  const { isConnected, address, chainId, isSwitchNetworkLoading } =
    useConnection();
  const { isBoringV1ContextReady, fetchUserShares } = useBoringVaultV1();
  const [balance, setBalance] = useState(ZERO);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchBalance() {
      if (
        !isBoringV1ContextReady ||
        !isConnected ||
        !address ||
        !chainId ||
        isSwitchNetworkLoading
      ) {
        setIsLoading(true);
        setBalance(ZERO);

        return;
      }

      setIsLoading(true);

      try {
        const shares = await fetchUserShares(address);
        setBalance(new BigNumber(shares));
      } catch (error) {
        console.error('Failed to fetch vault balance:', error);
        setBalance(ZERO);
      } finally {
        setIsLoading(false);
      }
    }

    void fetchBalance();
  }, [
    isBoringV1ContextReady,
    isConnected,
    chainId,
    address,
    fetchUserShares,
    isSwitchNetworkLoading,
  ]);

  return { balance, isLoading: isLoading || !isBoringV1ContextReady };
}
